import type { UserPublic } from '@repo/types/users';

import { cn } from '@repo/lib/cn';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getAvatar } from '@/utils/getAvatar';

export function getChildInitials(child: Pick<UserPublic, 'name' | 'surname'>) {
  return `${child.name.charAt(0)}${child.surname.charAt(0)}`.toUpperCase();
}

export function getChildFullName(child: Pick<UserPublic, 'name' | 'surname'>) {
  return `${child.name} ${child.surname}`.trim();
}

interface ChildAvatarProps {
  child: UserPublic;
  className?: string;
}

export function ChildAvatar(childAvatarProps: ChildAvatarProps) {
  const { child, className } = childAvatarProps;
  const fullName = getChildFullName(child);

  return (
    <Avatar className={cn('size-8', className)}>
      {/*
        The backend returns a path relative to the API host, not a usable URL —
        getAvatar prefixes it with VITE_API_DOMAIN.
      */}
      <AvatarImage src={getAvatar(child.avatarURL)} alt={fullName} />
      <AvatarFallback>{getChildInitials(child)}</AvatarFallback>
    </Avatar>
  );
}
